﻿
import { ioDatatypes } from "../../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter, ReactBootstrap, ReactLoader as Loader, Cookie } from "../../blib.js";

import * as xlib from "../../../../xlib/index.js";
import * as blib from "../../../../blib/index.js";

import bluebird from "bluebird";

import { IndexRoute, Router, Route, Link } from "react-router";
///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)





// import Cookie = blib.Cookie;

// //var xlib = refs.xlib;
// var _ = xlib.lodash;
// var __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//var jsHelper = xlib.jsHelper;

//import blib = refs.blib;


// import React = blib.React;
// import ReactDOM = blib.ReactDOM;
// import Redux = blib.Redux;
// import ReactRedux = blib.ReactRedux;
// import ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
// import History = blib.History;
// import ReactBootstrap = blib.ReactBootstrap;
// var ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import ioDatatypes = refs.ioDatatypes;

import * as config from "../client-config.js";

import * as commonComponents from "./commoncomponents.js";

import { errorPopupContent } from "./error-popup.js";
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////

export module components {

	let ReactRecaptcha = blib.ReactRecaptcha;

	class _StartSignup extends commonComponents.ReactRouterComponent<{ pushPath: typeof ReduxSimpleRouter.pushPath }, { email?: string; recaptchaResponse?: string; triedSubmitWithoutRecaptch?: boolean; }>{
		constructor( props: any ) {
			super( props );
			this.state = { email: null, recaptchaResponse: null, triedSubmitWithoutRecaptch: false };

		}

		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();
			//blib.googleAnalytics("send", "event", "signup", "start","loadPage");
		}
		render() {
			return (
				<div>
					<commonComponents.EzModal ref="Modal" />
					<div className="card">
						<div className="card-block">

							<div className="card-title">
								<h4>Create an Account</h4>
							</div>
							<form onSubmit={ this.handleSubmit.bind( this ) } >
								<fieldset className="form-group">
									<label htmlFor="emailInput">Email address</label>
									<input type="email" className="form-control" id="emailInput" placeholder="Enter email" value={ this.state.email } onChange={ ( e: React.FormEvent ) => { this.setState( { email: e.target.value } ) } } />
								</fieldset>

								<ReactRecaptcha sitekey={ config.RECAPTCHA_SITE_KEY } onChange={ this.onRecaptchaResponse.bind( this ) } />
								<br />
								{ this._render_SubmitAfterRecaptcha() }

							</form>
						</div>
					</div>
					<div className="col-sm-12">Already have an account? &nbsp; <ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.login }><strong>Log in instead</strong></ReactRouter.Link>.</div>
				</div>
			);
		}


		private _render_SubmitAfterRecaptcha() {

			if ( this.state.recaptchaResponse == null ) {
				return (
					<div>
						<button className="btn btn-default" onClick={ ( e ) => { e.preventDefault(); this.setState( { triedSubmitWithoutRecaptch: true } ); } }><div className="muted">Sign up</div></button>&nbsp;
						<div hidden={ this.state.triedSubmitWithoutRecaptch !== true } className="label label-danger">Please do the above CAPTCHA first!</div>
					</div> )
			} else {
				return (
					<button type="submit" className="btn btn-primary">Sign up</button>
				);
			}
		}
		private onRecaptchaResponse( recaptchaResponse: string ) {
			this.setState( { recaptchaResponse } );
		}
		//handleClick(e: React.FormEvent) {

		//          //e.preventDefault(); //prevent browser default action of submitting

		//	let newValue = e.target["checked"] as boolean;

		//	log.debug("_AddPrepaidCredit.handleClick()", { newValue, isAutoAddChecked: this.state.checked });//, e, target: e.target });

		//	this.setState({ checked: !this.state.checked });
		//}

		//private openConfirmModal(email: string) {
		//	var modal = this.refs["Modal"] as commonComponents.EzModal;

		//	let title = <span>Send Sign Up email to <strong>{email}</strong>?</span>
		//	let message = <span>Please make sure you entered your email address correctly.If not, cancel and re-submit.</span>
		//	//let details = <h3>{email}</h3>
		//	return modal.Show(title, message, null, { confirmButtonText: "Send Email" });
		//}

		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error Starting the Signup Process", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private handleSubmit( e: React.FormEvent ) {
			//log.trace("Login.handleSubmit", e);
			e.preventDefault(); //prevent browser default action of submitting
			//log.info("handleSubmit", { e, target: __.JSONX.inspectJSONify(e.target) });
			//console.assert(false);
			let email = this.state.email.toLowerCase();

			let recaptchaResponse = this.state.recaptchaResponse;
			//return this.openConfirmModal(email)
			//	.then(() => {
			var origin = window.location.origin;
			var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_signup_email_start;

			log.debug( target );
			return bluebird.try( () => {
				return xlib.net.axiosPost( target, { email, recaptchaResponse } )
					.then( ( response ) => {
						//var responsePayload = response.data;
						//log.info("Login.handleSubmit.responsePayload", response);
						this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signupEmailCheckEmail + "?email=" + encodeURIComponent( email ) );
					} )
					.catch( ( err ) => {
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
					} );
			} );
		}
	}
	export var StartSignup = ReactRedux.connect(
		null //(reduxStoreState) => _.clone(reduxStoreState.modalPopup) //subscripbe to reduxStore updates (Called every change). 
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _StartSignup );


	export class SignupEmailCheckEmail extends commonComponents.ReactRouterComponent<{}, {}>{

		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();
			//blib.googleAnalytics("send", "event", "signup", "start","loadPage");
		}
		render() {
			return (
				<section>
					<div className="col-sm12">
						<h4>Sign Up mail sent to <strong>{ this.props.location.query[ "email" ] }</strong>.</h4>
						<p>Please check your email inbox.  An email was sent to you from <b><a href="mailto:Support@PhantomJsCloud.com">Support@PhantomJsCloud.com</a></b>, please open it and follow it's instructions to activate your account.<strong><em>You must complete this process in 24 hours or you will need to restart it again.</em></strong></p>
					</div>
				</section>
			);
		}
	}

	class _SignupEmailSetPassword extends commonComponents.ReactRouterComponent<{ pushPath: typeof ReduxSimpleRouter.pushPath }, { email?: string; signupToken?: string; password?: string, isAutoFilledFieldsReadOnly?: boolean; }>{
		constructor( props: any ) {
			super( props );
			this.state = { email: null, signupToken: null, password: null };
		}


		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();
		}

		componentDidMount() {
			//look for querystrings

			//log.info("props", this.props);  

			let email = this.props.location.query[ "email" ];
			if ( email == null && this.props.location.query[ "emailEnc" ] != null ) {
				email = xlib.stringHelper.base64Url.decode( this.props.location.query[ "emailEnc" ] );
			}

			let signupToken = this.props.location.query[ "signupToken" ];
			if ( signupToken == null && this.props.location.query[ "signupTokenEnc" ] != null ) {
				signupToken = xlib.stringHelper.base64Url.decode( this.props.location.query[ "signupTokenEnc" ] );
			}

			let isAutoFilledFieldsReadOnly = false;
			if ( email != null && signupToken != null ) {
				isAutoFilledFieldsReadOnly = true;
			}

			this.setState( { email, signupToken, isAutoFilledFieldsReadOnly } );
		}

		render() {

			return (
				<div>
					<commonComponents.EzModal ref="Modal" />
					<div className="card">
						<div className="card-block">

							<div className="card-title">
								<h4>Finish Creating your account</h4>
							</div>
							<form onSubmit={ this.handleSubmit.bind( this ) } >
								<fieldset className="form-group">
									<label htmlFor="signupToken">Token <em>(set by email link)</em></label>
									<input
										type="text"
										className="form-control"
										id="signupToken"
										placeholder="a1b2c-a1b2c-a1b2c-a1b2c-a1b2c"
										value={ this.state.signupToken }
										onChange={ ( e: React.FormEvent ) => { this.setState( { signupToken: e.target.value } ) } }
										readOnly={ this.state.isAutoFilledFieldsReadOnly }
									/>
								</fieldset>
								<fieldset className="form-group">
									<label htmlFor="emailInput">Email address</label>
									<input
										type="email"
										className="form-control"
										id="emailInput"
										placeholder=""
										value={ this.state.email }
										onChange={ ( e: React.FormEvent ) => { this.setState( { email: e.target.value } ) } }
										readOnly={ this.state.isAutoFilledFieldsReadOnly }
									/>
								</fieldset>
								<fieldset className="form-group">
									<label htmlFor="password">Password</label>
									<input
										type="password"
										className="form-control"
										id="password"
										placeholder=""
										value={ this.state.password }
										onChange={ ( e: React.FormEvent ) => { this.setState( { password: e.target.value } ) } }
									/>
								</fieldset>

								<button type="submit" className="btn btn-primary">Finish and Log In</button>
							</form>
						</div>
					</div>

				</div>
			);
			//<div className="col-sm-12">Dont have a <em><u>[PhantomJsCloud] Please confirm your Email</u></em> email in your inbox?<ReactRouter.Link to={config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signup}><strong>Restart the account creation process</strong></ReactRouter.Link>.</div>
		}


		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error Finalizing your Account Creation", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}



		//private openSuccessModal(){			
		//    var title = "Account Created.";
		//    var message = "Your account has been created and your password set.  We will now automatically Log In. ";
		//    var modal = this.refs["Modal"] as commonComponents.EzModal;
		//    return modal.Show(title, message, null);
		//}

		private handleSubmit( e: React.FormEvent ) {
			//log.assert(false,"EndReset.handleSubmit", e);
			e.preventDefault(); //prevent browser default action of submitting

			//verify both passwords match
			//if (this.state.password !== this.state.passwordConfirm) {
			//    this.openErrorModal("The passwords you typed do not match");
			//    return;
			//}
			try {


				__.scrub( this.state ).isReal( "all fields are required", true ).failThrow();

				var signupToken = xlib.security.humanFriendlyKey( undefined, undefined, this.state.signupToken );

				var passwordSha512Hash = xlib.security.sha512( this.state.password );



				var origin = window.location.origin;
				var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_signup_email_finish;

				var payload: ioDatatypes.authentication.Payload_SignupEmailFinish = {//  typeof ioDatatypes.authentication.templates.T_payload_signupEmailFinish = {
					email: this.state.email,
					passwordSha512Hash: passwordSha512Hash,
					signupToken: signupToken,
				};
				log.debug( target );
				xlib.net.axiosPost( target, payload )
					.then( ( response ) => {

						blib.googleAnalytics( "send", "event", "signup", "finish", "firstLogin", 1 );
						//return this.openSuccessModal()
						//.then(()=>{
						//    //var responsePayload = response.data;
						//    //log.info("Login.handleSubmit.responsePayload", response);
						this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root );
						//    });
					} )
					.catch( ( err ) => {
						log.debug( ".catch()", { err } );
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
					} );
			} catch ( err ) {
				this.openErrorModal( err );
			}
		}
	}
	export var SignupEmailSetPassword = ReactRedux.connect(
		null //(reduxStoreState) => _.clone(reduxStoreState.modalPopup) //subscripbe to reduxStore updates (Called every change). 
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _SignupEmailSetPassword );




}

